export const mapEventValuesName = (filterKey) => {
  switch (filterKey) {
    case 'propertyTypes':
      return {
        groupName: 'Property Type',
        itemName: 'property type',
      };
    case 'facilities':
      return {
        groupName: 'Facilities',
        itemName: 'facility',
      };
    case 'subRegions':
      return {
        groupName: 'Area',
        itemName: 'area',
      };
    case 'popularFilters':
      return {
        groupName: 'Popular Filters',
        itemName: 'popular filters',
      };
    default:
  }
};
